import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { UncontrolledPopover, PopoverBody } from 'reactstrap';
import { getAppContainer } from '../../containers/App/selectors';

class TableTags extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validTags: [],
      restTags: [],
    };

    this.tagsRef = React.createRef();

    this.tagLength = this.props.tagLength || 15
    this.iconLength = this.props.iconLength || 15
    this.maxCount = this.props.maxCount || 2
  }

  // eslint-disable-next-line
  componentWillReceiveProps(nextProps) {
    const { tags, icon } = nextProps;
    this.groupTags(tags, icon)
  }

  componentDidMount() {
    const { icon, tags } = this.props;
    this.groupTags(tags, icon)
  }

  groupTags = (tags = [], icon) => {
    let validTags = [];
    let restTags = [];
    let allWords = '';

    if (tags.length === 1) {
      validTags = tags
    } else {
      tags.forEach((tag) => {
        allWords = allWords.concat(tag);
        if (allWords.length >= (icon ? this.iconLength : this.tagLength)) {
          restTags.push(tag);
        }

        if (allWords.length < (icon ? this.iconLength : this.tagLength)) {
          validTags.push(tag);
        }

        if (tag.length < (icon ? this.iconLength : this.tagLength) && !validTags.length) {
          validTags.push(tag);
        }
      });
    }

    this.setState({ validTags, restTags });
  }

  onTagClick = (e, tag) => {
    
    if(this.props.onClick) {
      e.preventDefault()
      e.stopPropagation()
      this.props.onClick(tag)
    }
  }

  getExtraTagsLength = () => this.getExtraTags().length

  getExtraTags = () => this.props.tags.slice(this.maxCount)

  renderExtraTags = restTags =>
  // const extraTagsLength = this.getExtraTagsLength()
  // const extraTags = this.getExtraTags()

  (
    <>
      <div className="tags__count" ref={this.tagsRef}>
        +
        {restTags.length}
      </div>
      <UncontrolledPopover trigger="hover" target={this.tagsRef.current} className="tags-popover" container={this.props.appContainer || document.body}>
        <PopoverBody>
          {restTags.map(extraTag => (
            <div className="tag-popover" key={extraTag}>{extraTag}</div>
          ))}
        </PopoverBody>
      </UncontrolledPopover>
    </>
  )


  render() {
    const { icon, noWrap, isPlain } = this.props;
    const { validTags, restTags } = this.state;

    return (
      <div className={classNames('tags ellipsis', noWrap && 'tags--nowrap', { [`tags_${this.props.colorClassName}`]: this.props.colorClassName })}>
        {validTags.map((tag) => {
          if (icon) {
            return (
              <div key={tag} className={classNames('tags__item', isPlain && 'tags__item--plain')} onClick={(e) => this.onTagClick(e, tag)}>
                {icon}
                {' '}
                {tag}
              </div>
            );
          }
          return <div key={tag} className={classNames('tags__item', isPlain && 'tags__item--plain')} onClick={(e) => this.onTagClick(e, tag)}>{tag}</div>;
        })}
        {restTags.length > 0 && this.renderExtraTags(restTags)}
      </div>
    );
  }
}

TableTags.propTypes = {
  tags: PropTypes.array,
  icon: PropTypes.object,
  colorClassName: PropTypes.string,
};

TableTags.deaultProps = {
  tags: [],
};

const mapStateToProps = (state) => ({
  appContainer: getAppContainer()(state)
});

export default connect(mapStateToProps)(TableTags);
